import { render } from "./Doc.vue?vue&type=template&id=308f83cd&scoped=true"
import script from "./Doc.vue?vue&type=script&lang=js"
export * from "./Doc.vue?vue&type=script&lang=js"

import "./Doc.vue?vue&type=style&index=0&id=308f83cd&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308f83cd"]])

export default __exports__